<template>
  <div>
    <template v-if="loading">
      <rfp-mctb-provider
        :buy-now="buyNow"
        :carousel-header="carouselHeader"
        :buynow-data="buynowData"
        :buy-online-button-text="buyOnlineButtonText"
        :buy-offline-button-text="buyOfflineButtonText"
        :star-inactive-color="starInactiveColor"
        :star-active-color="starActiveColor"
        :star-size="starSize"
        :enable-rtl="enableRtl"
        :component-diffs="true"
        :enable-buynow-retailers="hideBuyNowButton"
        :retailer-unavailable="retailerUnavailable"
      >
      </rfp-mctb-provider>
    </template>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import globalMixin from './global-mixin';
import RfpMctbProvider from './rfp-mctb-provider.vue';

export default {
  name: 'rfp-mctb-has-variant',
  components: {
    RfpMctbProvider,
  },
  mixins: [globalMixin],
  props: {
    buyOnlineButtonText: {
      type: String,
      default: 'Online',
    },
    buyOfflineButtonText: {
      type: String,
      default: 'Offline',
    },
    carouselHeader: {
      type: String,
      default: 'Header Text',
    },
    buyNow: {
      type: String,
      default: 'Buy Now',
    },
    starInactiveColor: {
      type: String,
      default: '#000',
    },
    starActiveColor: {
      type: String,
      default: '#f00',
    },
    starSize: {
      type: Number,
      default: 25,
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    retailerUnavailable: {
      type: String,
      default: 'unfortunatly no retailers are available at this moment.',
    },
  },
  created() {
    eventBus.emit('rfp-mctb-has-variant-component1');
  },
};
</script>
